'use client'

import { useEffect } from 'react'
import { setConnectivityOnline } from '@/lib/connectivity/store'

/**
 * Subscribes to `navigator.onLine` and syncs into the connectivity store.
 * Mount once inside the client provider tree.
 */
export default function ConnectivitySync() {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined

    const sync = () => setConnectivityOnline(navigator.onLine)
    sync()
    window.addEventListener('online', sync)
    window.addEventListener('offline', sync)
    return () => {
      window.removeEventListener('online', sync)
      window.removeEventListener('offline', sync)
    }
  }, [])

  return null
}
